import actions from "./actions";

const initState = {
    mpsLoginState: null,
    accessToken: null,
    mpsSyncState: null,
    invoice: null,

    floatingWindowVisible: false,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.TEST_MPS_LOGIN_REQUEST:
            return {
                ...state,
                mpsLoginState: 'request',
            };
        case actions.TEST_MPS_LOGIN_SUCCESS:
            return {
                ...state,
                mpsLoginState: 'success',
                accessToken: action.accessToken,
            };
        case actions.TEST_MPS_SYNC_REQUEST:
            return {
                ...state,
                mpsSyncState: 'request',
            };
        case actions.TEST_MPS_SYNC_SUCCESS:
            return {
                ...state,
                mpsSyncState: 'success',
                invoice: action.invoice,
            };

        case actions.TEST_FW_OPEN_MODAL:
            return {
                ...state,
                floatingWindowVisible: true,
            };
        case actions.TEST_FW_CLOSE_MODAL:
            return {
                ...state,
                floatingWindowVisible: false,
            };

        case actions.TEST_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
